import * as React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ParticipantCard from "./ParticipantCard";

/**
 * Props:
 *   open: boolean
 *   onClose: () => void
 *   participant: { firstName, lastName, email, phone?, hasOutstandingPayments }
 */
export default function ParticipantInfoDialog({ open, onClose, participant }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ pt: 5 }}>
        {participant && <ParticipantCard participant={participant} />}
      </DialogContent>
    </Dialog>
  );
}
